import { gql } from '@apollo/client';

export const UPDATE_UTILITY_CREDENTIAL = gql`
  mutation Flex_UpdateUtilityCredential($id: Int!, $input: UpdateUtilityCredentialInput!) {
    updateUtilityCredential(id: $id, input: $input) {
      id
      verificationStatus
    }
  }
`;
